// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Company Dashboard Design Tokens
 *
 * Source: .kiro/specs/company-dashboard-internal-pages/design.md
 *           § "Design System / Theme Tokens"
 *
 * These CSS custom properties mirror the Tailwind tokens added under the
 * \`dashboard.*\` and \`accent.*\` namespaces in \`tailwind.config.js\`. Use them
 * from raw CSS or inline styles when Tailwind utilities aren't ergonomic
 * (gradients, glassmorphism, animated shadows, etc.).
 *
 * Validates: Requirements 1.1, 1.2, 1.3, 1.4, 1.7, 1.8, 1.9
 */

:root {
  /* ── Surface ───────────────────────────────────────────────────── */
  --bg-app:    #0F1117;
  --bg-card:   #171A23;
  --bg-muted:  #1E2230;
  --bg-glass:  rgba(23, 26, 35, 0.84);

  /* ── Primary — soft purple/indigo gradient pair ─────────────────── */
  --primary-50:  rgba(37, 99, 235, 0.10);
  --primary-100: rgba(37, 99, 235, 0.16);
  --primary-200: rgba(37, 99, 235, 0.24);
  --primary-300: #93c5fd;
  --primary-400: #60a5fa;
  --primary-500: #2563EB;
  --primary-600: #2563EB;
  --primary-700: #1D4ED8;
  --primary-800: #1e40af;
  --primary-900: #1e3a8a;

  /* ── Accent — purple ramp (gradient end) ────────────────────────── */
  --accent-50:  rgba(37, 99, 235, 0.10);
  --accent-100: rgba(37, 99, 235, 0.16);
  --accent-200: rgba(37, 99, 235, 0.24);
  --accent-300: #93c5fd;
  --accent-400: #60a5fa;
  --accent-500: #2563EB;
  --accent-600: #2563EB;
  --accent-700: #1D4ED8;

  /* ── Gradients (hero, primary CTA, active nav) ──────────────────── */
  --gradient-primary: #2563EB;
  --gradient-hero:    #0F1117;
  --gradient-soft:    #171A23;

  /* ── Borders ────────────────────────────────────────────────────── */
  --border-default: #2A3042;
  --border-strong:  #2A3042;
  --border-focus:   #2563EB;
  --border-glass:   #2A3042;

  /* ── Text ───────────────────────────────────────────────────────── */
  --text-primary:   #FFFFFF;
  --text-secondary: #A1A8B8;
  --text-muted:     #6B7280;
  --text-tertiary:  #6B7280;
  --text-on-primary: #ffffff;

  /* ── Status (used as accents only) ──────────────────────────────── */
  --status-success: #2563EB;
  --status-warning: #2563EB;
  --status-danger:  #2563EB;
  --status-info:    #2563EB;
  --status-live:    #2563EB;

  /* ── Typography (Req 1.8: body 12-14px, headings 14-32px) ───────── */
  --font-sans: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  --text-xs:   12px;
  --text-sm:   13px;
  --text-base: 14px;
  --text-lg:   16px;
  --text-xl:   18px;
  --text-2xl:  22px;
  --text-3xl:  28px;
  --text-4xl:  32px;

  --font-weight-normal:    400;
  --font-weight-medium:    500;
  --font-weight-semibold:  600;
  --font-weight-bold:      700;
  --font-weight-extrabold: 800;

  --letter-spacing-tight: -0.01em;

  /* ── Spacing (4px base) ─────────────────────────────────────────── */
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;       /* card content padding minimum (Req 1.3) */
  --space-5: 20px;
  --space-6: 24px;
  --space-7: 28px;
  --space-8: 32px;
  --space-10: 40px;
  --space-12: 48px;

  /* ── Radii (per Req 1.3 — cards 12-20px) ───────────────────────── */
  --radius-sm:    8px;              /* tags, inputs */
  --radius-md:   12px;              /* most cards (Req 1.3 lower bound) */
  --radius-lg:   16px;              /* large cards, modals */
  --radius-xl:   20px;              /* hero, glass surfaces (Req 1.3 upper bound) */
  --radius-2xl:  24px;              /* media containers */
  --radius-full: 9999px;

  /* ── Shadows ────────────────────────────────────────────────────── */
  --shadow-sm:  0 1px 2px rgba(0, 0, 0, 0.35);
  --shadow-md:  0 4px 12px rgba(0, 0, 0, 0.4);
  --shadow-lg:  0 10px 30px rgba(0, 0, 0, 0.45);
  --shadow-cta: 0 10px 24px rgba(37, 99, 235, 0.22);
  --shadow-cta-lg: 0 14px 32px rgba(37, 99, 235, 0.26);
  --shadow-glass:  0 10px 30px rgba(0, 0, 0, 0.35);

  /* ── Layout ─────────────────────────────────────────────────────── */
  --sidebar-width: 260px;
  --rightrail-width: 320px;
  --topnav-height: 64px;

  /* ── Motion ─────────────────────────────────────────────────────── */
  --duration-fast: 150ms;
  --duration-base: 200ms;
  --duration-slow: 300ms;
  --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);

  /* ── Z-index ────────────────────────────────────────────────────── */
  --z-sidebar: 30;
  --z-topnav: 40;
  --z-dropdown: 50;
  --z-modal-backdrop: 60;
  --z-modal: 70;
  --z-toast: 80;
  --z-cmdk: 90;
  --z-fab: 25;
}

/* ── Dark mode dashboard tokens ───────────────────────────────────── */
html.dark {
  --bg-app:    #0F1117;
  --bg-card:   #171A23;
  --bg-muted:  #1E2230;
  --bg-glass:  rgba(23, 26, 35, 0.84);
  --gradient-hero: #0F1117;
  --gradient-soft: #171A23;
  --border-default: #2A3042;
  --border-strong:  #2A3042;
  --border-glass:   #2A3042;
  --text-primary:   #FFFFFF;
  --text-secondary: #A1A8B8;
  --text-muted:     #6B7280;
  --text-tertiary:  #6B7280;
  --shadow-sm:  0 1px 2px rgba(0, 0, 0, 0.35);
  --shadow-md:  0 4px 12px rgba(0, 0, 0, 0.4);
  --shadow-lg:  0 10px 30px rgba(0, 0, 0, 0.45);
  --shadow-glass: 0 10px 30px rgba(0, 0, 0, 0.35);
}

html.dark .glass {
  background: var(--bg-glass);
  border-color: var(--border-glass);
}

html.dark .glass-strong {
  background: rgba(22, 22, 40, 0.92);
  border-color: var(--border-glass);
}

/* ───────────────────────────────────────────────────────────────────
 * Glassmorphism utility (Req 1.4)
 *
 * Applied to: Dashboard Home hero, Placement Room detail hero, Company
 * Profile public hero, Live Drive Control hero.
 * ─────────────────────────────────────────────────────────────────── */
.glass {
  background: var(--bg-glass);
  backdrop-filter: blur(12px) saturate(140%);
  border: 1px solid var(--border-glass);
  box-shadow: var(--shadow-glass);
}

.glass-strong {
  background: rgba(23, 26, 35, 0.92);
  backdrop-filter: blur(20px) saturate(160%);
  border: 1px solid var(--border-glass);
  box-shadow: var(--shadow-lg);
}

/* ───────────────────────────────────────────────────────────────────
 * Floating Action Button base (Req 1.9)
 * Anchored bottom-right with soft purple gradient.
 * ─────────────────────────────────────────────────────────────────── */
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  background: #2563EB;
  border-radius: var(--radius-full);
  box-shadow: var(--shadow-cta);
  color: var(--text-on-primary);
  z-index: var(--z-fab);
  transition: transform var(--duration-base) var(--ease-out-expo),
              box-shadow var(--duration-base) var(--ease-out-expo);
}

.fab:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-cta-lg);
}

/* ───────────────────────────────────────────────────────────────────
 * Live status pulse dot (used by LiveStatusBadge)
 * ─────────────────────────────────────────────────────────────────── */
@keyframes dashboard-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%      { opacity: 0.5; transform: scale(0.85); }
}

.live-pulse-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  background: var(--status-live);
  box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.5);
  animation: dashboard-pulse 1.5s ease-in-out infinite;
}

/* ───────────────────────────────────────────────────────────────────
 * Reduced motion support
 * ─────────────────────────────────────────────────────────────────── */
@media (prefers-reduced-motion: reduce) {
  .fab,
  .live-pulse-dot {
    animation: none;
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF;EACE,qEAAqE;EACrE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;;EAEnC,sEAAsE;EACtE,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,sEAAsE;EACtE,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,sEAAsE;EACtE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,sEAAsE;EACtE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,sEAAsE;EACtE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;;EAE1B,sEAAsE;EACtE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,sEAAsE;EACtE,2HAA2H;EAC3H,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,+BAA+B;;EAE/B,sEAAsE;EACtE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe,QAAQ,2CAA2C;EAClE,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,qEAAqE;EACrE,mBAAmB,eAAe,iBAAiB;EACnD,mBAAmB,eAAe,qCAAqC;EACvE,mBAAmB,eAAe,wBAAwB;EAC1D,mBAAmB,eAAe,+CAA+C;EACjF,mBAAmB,eAAe,qBAAqB;EACvD,qBAAqB;;EAErB,sEAAsE;EACtE,2CAA2C;EAC3C,2CAA2C;EAC3C,6CAA6C;EAC7C,iDAAiD;EACjD,oDAAoD;EACpD,gDAAgD;;EAEhD,sEAAsE;EACtE,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;;EAErB,sEAAsE;EACtE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,8CAA8C;;EAE9C,sEAAsE;EACtE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA,wEAAwE;AACxE;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;EAC3C,2CAA2C;EAC3C,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;;;;wEAKwE;AACxE;EACE,2BAA2B;EAE3B,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAElC,0CAA0C;EAC1C,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;;;wEAGwE;AACxE;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB;kEACgE;AAClE;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;wEAEwE;AACxE;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,WAAW,YAAY,EAAE,sBAAsB,EAAE;AACnD;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,8BAA8B;EAC9B,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;;wEAEwE;AACxE;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Company Dashboard Design Tokens\n *\n * Source: .kiro/specs/company-dashboard-internal-pages/design.md\n *           § \"Design System / Theme Tokens\"\n *\n * These CSS custom properties mirror the Tailwind tokens added under the\n * `dashboard.*` and `accent.*` namespaces in `tailwind.config.js`. Use them\n * from raw CSS or inline styles when Tailwind utilities aren't ergonomic\n * (gradients, glassmorphism, animated shadows, etc.).\n *\n * Validates: Requirements 1.1, 1.2, 1.3, 1.4, 1.7, 1.8, 1.9\n */\n\n:root {\n  /* ── Surface ───────────────────────────────────────────────────── */\n  --bg-app:    #0F1117;\n  --bg-card:   #171A23;\n  --bg-muted:  #1E2230;\n  --bg-glass:  rgba(23, 26, 35, 0.84);\n\n  /* ── Primary — soft purple/indigo gradient pair ─────────────────── */\n  --primary-50:  rgba(37, 99, 235, 0.10);\n  --primary-100: rgba(37, 99, 235, 0.16);\n  --primary-200: rgba(37, 99, 235, 0.24);\n  --primary-300: #93c5fd;\n  --primary-400: #60a5fa;\n  --primary-500: #2563EB;\n  --primary-600: #2563EB;\n  --primary-700: #1D4ED8;\n  --primary-800: #1e40af;\n  --primary-900: #1e3a8a;\n\n  /* ── Accent — purple ramp (gradient end) ────────────────────────── */\n  --accent-50:  rgba(37, 99, 235, 0.10);\n  --accent-100: rgba(37, 99, 235, 0.16);\n  --accent-200: rgba(37, 99, 235, 0.24);\n  --accent-300: #93c5fd;\n  --accent-400: #60a5fa;\n  --accent-500: #2563EB;\n  --accent-600: #2563EB;\n  --accent-700: #1D4ED8;\n\n  /* ── Gradients (hero, primary CTA, active nav) ──────────────────── */\n  --gradient-primary: #2563EB;\n  --gradient-hero:    #0F1117;\n  --gradient-soft:    #171A23;\n\n  /* ── Borders ────────────────────────────────────────────────────── */\n  --border-default: #2A3042;\n  --border-strong:  #2A3042;\n  --border-focus:   #2563EB;\n  --border-glass:   #2A3042;\n\n  /* ── Text ───────────────────────────────────────────────────────── */\n  --text-primary:   #FFFFFF;\n  --text-secondary: #A1A8B8;\n  --text-muted:     #6B7280;\n  --text-tertiary:  #6B7280;\n  --text-on-primary: #ffffff;\n\n  /* ── Status (used as accents only) ──────────────────────────────── */\n  --status-success: #2563EB;\n  --status-warning: #2563EB;\n  --status-danger:  #2563EB;\n  --status-info:    #2563EB;\n  --status-live:    #2563EB;\n\n  /* ── Typography (Req 1.8: body 12-14px, headings 14-32px) ───────── */\n  --font-sans: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  --text-xs:   12px;\n  --text-sm:   13px;\n  --text-base: 14px;\n  --text-lg:   16px;\n  --text-xl:   18px;\n  --text-2xl:  22px;\n  --text-3xl:  28px;\n  --text-4xl:  32px;\n\n  --font-weight-normal:    400;\n  --font-weight-medium:    500;\n  --font-weight-semibold:  600;\n  --font-weight-bold:      700;\n  --font-weight-extrabold: 800;\n\n  --letter-spacing-tight: -0.01em;\n\n  /* ── Spacing (4px base) ─────────────────────────────────────────── */\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;       /* card content padding minimum (Req 1.3) */\n  --space-5: 20px;\n  --space-6: 24px;\n  --space-7: 28px;\n  --space-8: 32px;\n  --space-10: 40px;\n  --space-12: 48px;\n\n  /* ── Radii (per Req 1.3 — cards 12-20px) ───────────────────────── */\n  --radius-sm:    8px;              /* tags, inputs */\n  --radius-md:   12px;              /* most cards (Req 1.3 lower bound) */\n  --radius-lg:   16px;              /* large cards, modals */\n  --radius-xl:   20px;              /* hero, glass surfaces (Req 1.3 upper bound) */\n  --radius-2xl:  24px;              /* media containers */\n  --radius-full: 9999px;\n\n  /* ── Shadows ────────────────────────────────────────────────────── */\n  --shadow-sm:  0 1px 2px rgba(0, 0, 0, 0.35);\n  --shadow-md:  0 4px 12px rgba(0, 0, 0, 0.4);\n  --shadow-lg:  0 10px 30px rgba(0, 0, 0, 0.45);\n  --shadow-cta: 0 10px 24px rgba(37, 99, 235, 0.22);\n  --shadow-cta-lg: 0 14px 32px rgba(37, 99, 235, 0.26);\n  --shadow-glass:  0 10px 30px rgba(0, 0, 0, 0.35);\n\n  /* ── Layout ─────────────────────────────────────────────────────── */\n  --sidebar-width: 260px;\n  --rightrail-width: 320px;\n  --topnav-height: 64px;\n\n  /* ── Motion ─────────────────────────────────────────────────────── */\n  --duration-fast: 150ms;\n  --duration-base: 200ms;\n  --duration-slow: 300ms;\n  --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);\n\n  /* ── Z-index ────────────────────────────────────────────────────── */\n  --z-sidebar: 30;\n  --z-topnav: 40;\n  --z-dropdown: 50;\n  --z-modal-backdrop: 60;\n  --z-modal: 70;\n  --z-toast: 80;\n  --z-cmdk: 90;\n  --z-fab: 25;\n}\n\n/* ── Dark mode dashboard tokens ───────────────────────────────────── */\nhtml.dark {\n  --bg-app:    #0F1117;\n  --bg-card:   #171A23;\n  --bg-muted:  #1E2230;\n  --bg-glass:  rgba(23, 26, 35, 0.84);\n  --gradient-hero: #0F1117;\n  --gradient-soft: #171A23;\n  --border-default: #2A3042;\n  --border-strong:  #2A3042;\n  --border-glass:   #2A3042;\n  --text-primary:   #FFFFFF;\n  --text-secondary: #A1A8B8;\n  --text-muted:     #6B7280;\n  --text-tertiary:  #6B7280;\n  --shadow-sm:  0 1px 2px rgba(0, 0, 0, 0.35);\n  --shadow-md:  0 4px 12px rgba(0, 0, 0, 0.4);\n  --shadow-lg:  0 10px 30px rgba(0, 0, 0, 0.45);\n  --shadow-glass: 0 10px 30px rgba(0, 0, 0, 0.35);\n}\n\nhtml.dark .glass {\n  background: var(--bg-glass);\n  border-color: var(--border-glass);\n}\n\nhtml.dark .glass-strong {\n  background: rgba(22, 22, 40, 0.92);\n  border-color: var(--border-glass);\n}\n\n/* ───────────────────────────────────────────────────────────────────\n * Glassmorphism utility (Req 1.4)\n *\n * Applied to: Dashboard Home hero, Placement Room detail hero, Company\n * Profile public hero, Live Drive Control hero.\n * ─────────────────────────────────────────────────────────────────── */\n.glass {\n  background: var(--bg-glass);\n  -webkit-backdrop-filter: blur(12px) saturate(140%);\n  backdrop-filter: blur(12px) saturate(140%);\n  border: 1px solid var(--border-glass);\n  box-shadow: var(--shadow-glass);\n}\n\n.glass-strong {\n  background: rgba(23, 26, 35, 0.92);\n  -webkit-backdrop-filter: blur(20px) saturate(160%);\n  backdrop-filter: blur(20px) saturate(160%);\n  border: 1px solid var(--border-glass);\n  box-shadow: var(--shadow-lg);\n}\n\n/* ───────────────────────────────────────────────────────────────────\n * Floating Action Button base (Req 1.9)\n * Anchored bottom-right with soft purple gradient.\n * ─────────────────────────────────────────────────────────────────── */\n.fab {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  background: #2563EB;\n  border-radius: var(--radius-full);\n  box-shadow: var(--shadow-cta);\n  color: var(--text-on-primary);\n  z-index: var(--z-fab);\n  transition: transform var(--duration-base) var(--ease-out-expo),\n              box-shadow var(--duration-base) var(--ease-out-expo);\n}\n\n.fab:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-cta-lg);\n}\n\n/* ───────────────────────────────────────────────────────────────────\n * Live status pulse dot (used by LiveStatusBadge)\n * ─────────────────────────────────────────────────────────────────── */\n@keyframes dashboard-pulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50%      { opacity: 0.5; transform: scale(0.85); }\n}\n\n.live-pulse-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  background: var(--status-live);\n  box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.5);\n  animation: dashboard-pulse 1.5s ease-in-out infinite;\n}\n\n/* ───────────────────────────────────────────────────────────────────\n * Reduced motion support\n * ─────────────────────────────────────────────────────────────────── */\n@media (prefers-reduced-motion: reduce) {\n  .fab,\n  .live-pulse-dot {\n    animation: none;\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
